// Story 13630 — shared identity rules for editable/removable Ask More questions.
// Kept self-contained (no cross-repo import); caas-console carries its own copy.

export const newAskId = () =>
    `ask_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;

const hasText = (v) => Boolean((v ?? "").toString().trim());

// Identity of an ask. New asks always have ask_id; legacy rows fall back to a
// derived key that is stable for a single render pass.
export const askKey = (ask = {}, index = 0) =>
    ask?.ask_id ?? `legacy:${ask?.question_id || ask?.question || ""}:${ask?.askedAt ?? "na"}:${index}`;

export const isRemoved = (ask = {}) => ask?.removedAt != null;

export const isAnswered = (ask = {}) => hasText(ask?.response) || Boolean(ask?.attachment);

export const isActive = (ask = {}) => !isRemoved(ask);

export const getActiveAsks = (asks = []) => (asks || []).filter((a) => a && isActive(a));

export const getPendingAsks = (asks = []) => getActiveAsks(asks).filter((a) => !isAnswered(a));

export const hasActiveAsks = (asks = []) => getActiveAsks(asks).length > 0;

export const hasPendingAsks = (asks = []) => getPendingAsks(asks).length > 0;

// Stable storage key for DOCUMENT-type asks so editing the display label never
// orphans an uploaded document.
export const documentFieldKey = (ask = {}) =>
    ask?.documentFieldKey || ask?.ask_id || ask?.originalQuestion || ask?.question || "";
